import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import React from 'react';
import SGSPyramidChart from '../../../components/Charts/SGSPyramid';
import { useStatisticsContext } from '../contexts/StatistiquesProvider';
import style from '../../../features/statistiques/css/Statistics.module.scss';
import CustomLegend from './CustomLegend';

type Props = {};

const PyramideAge: React.FC<Props> = () => {
    const { pyramidAge, isLoadingPyramidAge } = useStatisticsContext();
    return (
        <>
            <Card className="w-100" style={{ boxShadow: 'none' }}>
                <CardHeader title="Pyramide des ages des assurés" className={style.graphsTitle} />
                <CardContent className={style.chartBox}>
                    <Box className={style.graphsDivider}></Box>
                    {!isLoadingPyramidAge ? (
                        <>
                            <SGSPyramidChart
                                data={pyramidAge}
                                legend={false}
                                legendLabels={{ uv: 'Homme', pv: 'Femme' }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginLeft: '50px',
                                    bgcolor: 'background.paper',
                                    borderRadius: 1,
                                    justifyContent: 'center',
                                }}
                            >
                                <CustomLegend
                                    label="Femme"
                                    bkgClass={style.blueBkg}
                                    color={style.blueColor}
                                ></CustomLegend>
                                <CustomLegend
                                    label="Homme"
                                    bkgClass={style.redBkg}
                                    color={style.redColor}
                                ></CustomLegend>
                            </Box>
                        </>
                    ) : (
                        'Loading...'
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default PyramideAge;
